export function canApplyExploreFilters(input: {
  competitorOptionsReady: boolean;
  draftComplete: boolean;
  isOverviewRoute: boolean;
  overviewDirty: boolean;
  isDrilldownRoute: boolean;
  drilldownDirty: boolean;
}): boolean {
  if (!input.competitorOptionsReady) return false;
  return (
    input.draftComplete ||
    (input.isOverviewRoute && input.overviewDirty) ||
    (input.isDrilldownRoute && input.drilldownDirty)
  );
}

export type ExploreApplyDisableReason = "incomplete" | "roster-loading" | "roster-error";

export function resolveExploreApplyDisableReason(input: {
  canApply: boolean;
  competitorOptionsReady: boolean;
  competitorBrandsError: boolean;
  competitorBrandsLoading: boolean;
}): ExploreApplyDisableReason | undefined {
  if (input.canApply) return undefined;
  if (!input.competitorOptionsReady && input.competitorBrandsError) return "roster-error";
  if (!input.competitorOptionsReady && input.competitorBrandsLoading) return "roster-loading";
  return "incomplete";
}
